import { constructQueryString } from '@/utils/queryBuilderUtils';

interface GetInfinityUrlProps {
  url: string;
  search: string | null;
  page: number | null;
  perPage?: number | null;
}

export const getInfinityUrl = ({ url, search, page, perPage }: GetInfinityUrlProps) => {
  // Split URL into base and existing query params
  const [baseUrl, existingParams] = url.split('?');

  // Parse existing query params
  const queryParams: Record<string, string> = {};

  if (existingParams) {
    const urlParams = new URLSearchParams(existingParams);
    urlParams.forEach((value, key) => {
      queryParams[key] = value;
    });
  }

  // Add new params (these will override existing ones with same key)
  if (search) queryParams.search = search;
  if (page) queryParams.page = String(page);
  if (perPage) queryParams.per_page = String(perPage);

  // Construct final URL
  if (Object.keys(queryParams).length > 0) {
    return `${baseUrl}?${constructQueryString(queryParams)}`;
  }

  return baseUrl;
};